<template>
  <div class="d-flex flex-column head align-items-center gap-3">
    <span class="title">{{ title }}</span>
    <div class="desc mb-3" v-html="descHtml"></div>
    <div class="d-flex gap-3">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EpiSimplyBookTitle",
  props: ["title", "desc"],
  computed: {
    descHtml() {
      return this.desc.replace(/\n/g, "<br/>");
    },
  },
};
</script>

<style lang="stylus">
purple-light = 171 172 211
purple-dark = 137 141 193
apricot-light = 252 236 227
apricot-dark = 254 235 226

text-gradient(c1, c2)
  background-color c2
  background-image linear-gradient(45deg, c1, c2)
  background-size 200% auto
  -webkit-background-clip text
  -moz-background-clip text
  -webkit-text-fill-color transparent
  -moz-text-fill-color transparent

.head
  background-image url('../../assets/rose.png')
  background-position center
  background-position-y 8rem
  background-repeat no-repeat
  background-size 30rem
  padding-top 32rem
  margin-bottom 14rem

.title
  font-size 4rem
  text-gradient(rgb(apricot-dark), rgb(purple-dark))
  font-weight bolder

.desc
  font-weight normal
  text-align center
  letter-spacing 0.3rem

@media (max-width: 768px)
  .head
    background-size 70%
    padding-top 90%
</style>
